export default "__VITE_ASSET__3768fd58__"